<!--
 * @Autor: haoyi
 * @LastEditors: haoyi
 * @LastEditTime: 2021-11-10 13:42:57
 * @Description:
-->
<template>
  <div id="app">
    <!-- <router-view /> -->
    <keep-alive>
      <router-view
        v-if="$route.meta.keepAlive"
        class="ui-view"
        transition-mode="out-in"
      ></router-view>
    </keep-alive>
    <router-view
      v-if="!$route.meta.keepAlive"
      class="ui-view"
      transition-mode="out-in"
    ></router-view>
  </div>
</template>
<script>
export default {
  name: 'App',
  created () {
    if (this.deviceType === 'weixin') {
      // 微信注册微信信息
      this.wxConfig()
    }
  },
  mounted () {
    document.querySelector('#pageLoading').style.display = 'none'
    this.appShareBtn()
    window.addEventListener('load', () => {
      if (window.CHENORMAL || window.CHESPEED) {
        const titleText = document.querySelector('title').innerText
        window.callNativeMethod('onChangeWebTitle', {
          changeWebTitle: titleText
        })
      }
      // 解决浏览器点击图片会放大
      document.addEventListener('click', e => {
        if (e.target.nodeName === 'IMG') {
          return false
        }
        // ios app 吊起电话
        if (e.target.nodeName === 'A' && window.CHEIOS && window.CHESPEED) {
          const href = e.target.getAttribute('href')
          if (href.indexOf('tel:') > -1) {
            e.preventDefault()
            const telNum = href.split(':')[1]
            if (!telNum) {
              return
            }
            window.callNativeMethod('onDial', {
              tel: telNum
            })
          }
        }
      })
    })
  }
}
</script>
<style lang="less">
@import './mixin/public.css';
#app {
  background: #0e316b;
  height: 100vh;
}
</style>
